import { WorkorderImportItem } from '@/core/domain/workorder/WorkOrdersImports/WorkOrderImports.types';
import { WorkOrderItemType } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { MathRound } from '@/utils/functions/MathRound';
import formatterNumber from '@/utils/number/formatterNumber';
import formatterPrice from '@/utils/number/formatterPrice';
import { Row, Col, Statistic, Divider, Typography } from 'antd';

type Props = {
  items: WorkorderImportItem[];
};

const WorkorderImportSummary: React.FC<Props> = ({ items }) => {
  const totalServiceHours = items
    ?.filter((item) => item.type === WorkOrderItemType.Service)
    .reduce((acc, item) => MathRound(acc, 2) + MathRound(item.quantity, 2), 0);

  const totalServiceAmount = items
    ?.filter((item) => item.type === WorkOrderItemType.Service)
    .reduce(
      (acc, item) =>
        MathRound(acc, 2) +
        MathRound(
          item.quantity * item.unitPrice -
            item.quantity * item.unitPrice * item.discount,
          2,
        ),
      0,
    );

  const totalPartQuantity = items
    ?.filter((item) => item.type === WorkOrderItemType.Part && !item.isProvided)
    .reduce((acc, item) => MathRound(acc, 2) + MathRound(item.quantity, 2), 0);

  const totalPartAmount = items
    ?.filter((item) => item.type === WorkOrderItemType.Part && !item.isProvided)
    .reduce(
      (acc, item) =>
        MathRound(acc, 2) +
        MathRound(
          item.quantity * item.unitPrice -
            item.quantity * item.unitPrice * item.discount,
          2,
        ),
      0,
    );

  return (
    <Row gutter={[16, 16]}>
      <Col>
        <Typography.Title level={5}>Serviços</Typography.Title>
        <Row gutter={[16, 16]}>
          <Col>
            <Statistic
              title="Total de horas"
              value={totalServiceHours}
              formatter={(value) => {
                const hours = Number(value).toFixed(0);
                const fraction = Number(value).toFixed(2).split('.')[1];
                const minutes = ((Number(fraction) / 1000) * 600).toFixed(0);

                return `${hours}:${String(minutes).padStart(2, '0')}`;
              }}
            />
          </Col>
          <Col>
            <Statistic
              title="Sub total"
              value={totalServiceAmount}
              formatter={(value) => formatterPrice(value as number)}
            />
          </Col>
        </Row>
      </Col>
      <Col>
        <Divider type="vertical" style={{ height: '100%' }} />
      </Col>
      <Col>
        <Typography.Title level={5}>Peças</Typography.Title>
        <Row gutter={[16, 16]}>
          <Col>
            <Statistic
              title="Quantidade total"
              value={totalPartQuantity}
              formatter={(value) => formatterNumber(value as number)}
            />
          </Col>
          <Col>
            <Statistic
              title="Sub total"
              value={totalPartAmount}
              formatter={(value) => formatterPrice(value as number)}
            />
          </Col>
        </Row>
      </Col>
      <Col>
        <Divider type="vertical" style={{ height: '100%' }} />
      </Col>
      <Col>
        <Typography.Title level={5}>Total</Typography.Title>
        <Statistic
          title="Valor total"
          value={totalPartAmount + totalServiceAmount}
          formatter={(value) => formatterPrice(value as number)}
        />
      </Col>
    </Row>
  );
};

export default WorkorderImportSummary;
